import { ContainsDissolvedSalt } from 'Components/Worksheets/Core/Fields';
import { FormatTypes } from 'Lib/Format';
import React, { useState } from 'react';
import { Button, Checkbox, Field, NumericInput, RadioGroup, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from '../../../../Layout';
import { IWorksheetComponent, WorksheetEquipmentDropdown } from '../../../Core';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';
import { GrainSize } from '../../types';

let BsPreparationSection: React.FC<IWorksheetComponent> = () => {
  const [testConditionsEditable, setTestConditionsEditable] = useState(false);

  return (
    <>
      {/* Editable fields */}
      <ListFieldSection visible={testConditionsEditable}>
        <Field input={<NumericInput />} name="Equipment.DryingTemperature" />
        <Field input={<Checkbox />} name="Preparation.ContainsGypsum" />
        <ContainsDissolvedSalt editable visible={testConditionsEditable} appendNamePrefix="Preparation" />
      </ListFieldSection>

      {/* Read-only fields */}
      <ListFieldSection visible={!testConditionsEditable}>
        <Field input={<TextOutput />} name="Equipment.DryingTemperature" />
        <Field input={<TextOutput />} name="Preparation.ContainsGypsum" format={{ type: FormatTypes.YesNo }} />
        <ContainsDissolvedSalt visible={!testConditionsEditable} appendNamePrefix="Preparation" />
      </ListFieldSection>
      <FieldSet visible={!testConditionsEditable}>
        <div>
          <Button
            onClick={() => {
              setTestConditionsEditable(true);
            }}
          >
            Change
          </Button>
        </div>
      </FieldSet>
      <Field
        input={<RadioGroup />}
        name="Preparation.GrainSize"
        options={[
          { label: 'Fine', value: GrainSize.Fine },
          { label: 'Medium', value: GrainSize.Medium },
          { label: 'Coarse', value: GrainSize.Coarse },
        ]}
      />
      <ListFieldSection>
        <WorksheetBalanceFieldSet name="Equipment.Balance" />
        <FieldSet>
          <Field input={<WorksheetEquipmentDropdown />} equipmentType="oven" name="Equipment.Oven" />
        </FieldSet>
      </ListFieldSection>
    </>
  );
};

BsPreparationSection = withInjectedProps(BsPreparationSection);

export { BsPreparationSection };
export default BsPreparationSection;
